import { Dialog, Typography } from '@mui/material';
import { FC } from 'react';
import { useTranslation } from 'react-i18next';
import { ColorPalette } from 'shared/consts/colorPalette';
import { ActionsForDialog } from 'shared/ui/ActionsForDialog';
import { Paper } from 'shared/ui/Paper';

type DeleteTableModalProps = {
	open: boolean;
	onCancel: () => void;
	onConfirm: () => void;
};

const DeleteTableModal: FC<DeleteTableModalProps> = ({ open, onCancel, onConfirm }) => {
	const { t } = useTranslation();

	return (
		<Dialog
			open={open}
			onClose={onCancel}
			PaperComponent={Paper}
			PaperProps={{ title: t('files.modal.delete_table_title') as string }}
		>
			<Typography variant={'body1'} color={ColorPalette.baliHai} sx={{ mb: 2 }}>
				{t('files.modal.delete_table_description')}
			</Typography>
			<ActionsForDialog
				cancelLabel={t('shared_texts.cancel')}
				cancelAction={onCancel}
				applyLabel={t('shared_texts.yes')}
				applyAction={onConfirm}
			/>
		</Dialog>
	);
};

export default DeleteTableModal;
